import styled from "styled-components";

const TextContainer = styled.div`
  ${({ theme }) => `padding: ${theme.sizes.sz8}`}
`;

export { TextContainer };
